import { gql } from 'urql';

export const ApplicationStatus = gql`
  query ApplicationStatus($applicationStatusId: ID!) {
    applicationStatus(id: $applicationStatusId)
  }
`;
